
export default [
  {
    path: '/paper-bank/:examBoard',
    name: 'paper-bank-examBoard',
    component: () => import('@/views/paper-bank/PaperBankView.vue')
  },
  {
    path: '/paper-bank/:examBoard/:subject',
    name: 'paper-bank-examBoard-subject',
    component: () => import('@/views/paper-bank/PaperBankSubjectView.vue'),
  },
  {
    path: '/paper-pdf-viewer',
    name: 'paper-pdf-viewer',
    component: () => import('@/views/paper-bank/PaperBankPdfView.vue'),
  },
];